import { Input, Typography } from 'antd'
import { FC, useEffect, useRef, useState } from 'react'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import { useUpdatePrintJobMutation } from '../../../../../store/api/print-jobs-api'
import PrintJob from '../../../../../types/api/print-job'

interface PrintJobNoteCellProps {
    printJob: PrintJob
    editable: boolean
}

const PrintJobNoteCell: FC<PrintJobNoteCellProps> = ({ printJob, editable }) => {
    const [value, setValue] = useState(printJob.printerComment ?? '')
    const savedValueRef = useRef(printJob.printerComment ?? '')
    const [updatePrintJob, updatePrintJobState] = useUpdatePrintJobMutation()

    useErrorModal(updatePrintJobState, 'Не удалось сохранить примечание')

    useEffect(() => {
        const synced = printJob.printerComment ?? ''
        setValue(synced)
        savedValueRef.current = synced
    }, [printJob.printerComment])

    const handleBlur = () => {
        const nextValue = value.trim()

        if (nextValue === savedValueRef.current.trim()) {
            return
        }

        updatePrintJob({
            docId: printJob.documentId,
            body: { data: { printerComment: nextValue } },
        })
            .unwrap()
            .then(() => {
                savedValueRef.current = nextValue
            })
    }

    if (!editable) {
        return <Typography.Text>{printJob.printerComment?.trim() || '—'}</Typography.Text>
    }

    return (
        <Input
            size="small"
            placeholder="Примечание"
            value={value}
            onChange={e => setValue(e.target.value)}
            onBlur={handleBlur}
            onClick={e => e.stopPropagation()}
            onMouseDown={e => e.stopPropagation()}
        />
    )
}

export default PrintJobNoteCell
